import Message from '@/components/c-toast/toast.vue'
let MessageInstanse = null
const MessagePlugin = {
  install(Vue) {
    if (!MessageInstanse) {
      // Vue.extend() 方法创建了一个名为 MessageComponent 的组件构造器。
      const MessageComponent = Vue.extend(Message);
      MessageInstanse = new MessageComponent();
      // 将通知组件挂载到DOM中
      const container = document.createElement("div");
      document.body.appendChild(container);
      MessageInstanse.$mount(container);
    }
    Vue.prototype.$Message = (message) => {
          MessageInstanse.show(message)
        }
    }
}
export default MessagePlugin
